import './style/index.js';

import _InputNumber from './input-number';

export type { InputNumberProps } from './input-number';
export const InputNumber = _InputNumber;

export default InputNumber;
